import QuestionEditorComponent from './components/QuestionEditorComponent.vue'
import { store, qEditorState } from './stores'
import { mathliveState } from './stores/mathlive'
import i18n from '../client/i18n'
import { IApplication } from '../../common/IApplication'

const app: IApplication = {
  elementId: 'question_editor',
  rootComponent: QuestionEditorComponent,
  stores: [
    {
      key: ['Editor'],
      module: store
    }
  ],
  i18n,
  // Vuetify is now configured globally in application.ts
  data: {
    dataStore: {
      qEditorState,
      mathliveState
    }
  }
}

export default app
